import React from 'react';
import cn from 'classnames';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Headroom from 'react-headroom';

import styles from './AboutUs.module.scss';

export default function AboutUs(props) {
  return (
    <React.Fragment>
      <Headroom tag="header" className="page-header">
        <nav className="max:show">
          <Header />
        </nav>
      </Headroom>

      <div className={cn(styles.root, 'about-us')}>
        <div className={styles.flex_col}>
          <h1 className={styles.hero_title}>ABOUT US</h1>
          <h3 className={styles.subtitle_box}>
            <span className={styles.subtitle}>
              <span className={styles.subtitle_span0}>Talenter: </span>
              <span className={styles.subtitle_span1}>Unleash your full potential</span>
              <span className={styles.subtitle_span2}>
                {' '}
                and redefine your career path. <br />
                Showcase your skills, achievements, and experience in one dynamic platform, and open the door to your
                dream job today.
              </span>
            </span>
          </h3>
          <div className={styles.flex_col__cell}>
            <img
              src={require('assets/1fc09225d5415b0c042d2358ad9103a5.png')}
              alt="alt text"
              className={styles.image1}
            />
          </div>
        </div>

        <div className={styles.content_box}>
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
}
